module.exports = __webpack_public_path__ + "img/Arrow.26f623b8.svg";